"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAuctionBidPlacedMockData = exports.buildAuctionBidCancelledMockData = exports.buildAuctionNewTopBidderMockData = exports.buildAuctionOutbidMockData = exports.buildAuctionThankYouNonWinnerMockData = exports.buildAuctionThankYouWinnerMockData = exports.FROALA_AUCTION_NON_WINNER_NOTE_BODY = exports.FROALA_AUCTION_WINNER_NOTE_BODY = void 0;
const email_theme_tokens_1 = require("../../helpers/email-theme-tokens");
const email_templates_1 = require("../../internationalization/locales/email-templates");
const icons_1 = require("../icons");
const format_mock_currency_1 = require("./format-mock-currency");
const MOCK_CONNECTION_LINK = "https://zeffy.com/my-account";
const MOCK_DONOR_REFUND_LINK = "https://zeffy.com/tip-adjustment";
const MOCK_CTA_URL = "https://www.zeffy.com/en-CA/auction/annual-auction-2026";
const FROALA_PARAGRAPH_STYLE = "width:100%;margin:0px;box-sizing:inherit;color:rgb(0, 0, 0);line-height:1.5;";
exports.FROALA_AUCTION_WINNER_NOTE_BODY = `<p style="${FROALA_PARAGRAPH_STYLE}">Hi John,</p>
<p style="${FROALA_PARAGRAPH_STYLE}">We are thrilled to announce that you are the winning bidder for the item(s) you selected in our silent auction! Your generosity and support are greatly appreciated, and we couldn't be more delighted to have you as a winner.</p>
<p style="${FROALA_PARAGRAPH_STYLE}">If you have any questions or need assistance, don't hesitate to contact us.</p>
<p style="${FROALA_PARAGRAPH_STYLE}">Once again, thank you for your participation and for helping us make a difference.</p>
<p style="${FROALA_PARAGRAPH_STYLE}">Warm regards,</p>
<p style="${FROALA_PARAGRAPH_STYLE}"><strong>The Green Foundation Team</strong></p>`;
exports.FROALA_AUCTION_NON_WINNER_NOTE_BODY = `<p style="${FROALA_PARAGRAPH_STYLE}">Hi John,</p>
<p style="${FROALA_PARAGRAPH_STYLE}">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
<p style="${FROALA_PARAGRAPH_STYLE}">Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
<p style="${FROALA_PARAGRAPH_STYLE}">Warm regards,</p>
<p style="${FROALA_PARAGRAPH_STYLE}"><strong>The Cool Foundation Team</strong></p>`;
const resolveBase = ({ color, isDarkMode, locale = "en" }) => {
    const labels = (0, email_templates_1.getEmailLabels)(locale);
    const theme = (0, email_theme_tokens_1.resolveEmailThemeTokens)(color || "#FFFFFF", isDarkMode ? "dark" : "light");
    const iconZeffyLogo = theme.zeffyLogoVariant === "dark" ? icons_1.EMAIL_ICON_DATA_URI.zeffyDark : icons_1.EMAIL_ICON_DATA_URI.zeffyLight;
    return { labels, theme, iconZeffyLogo, lang: locale };
};
const DEFAULT_WON_ITEMS = [
    { name: "Spa getaway for two", amountCents: 15000 },
    { name: "Backstage passes to Lakestreet Dive", amountCents: 25000 },
];
const buildAuctionThankYouWinnerMockData = (input) => {
    const { labels, theme, iconZeffyLogo, lang } = resolveBase(input);
    const formatAmount = (cents) => (0, format_mock_currency_1.formatMockCurrencyAmount)(cents, { locale: lang, country: input.country });
    const { orgName, firstName = "John", lastName = "Smith", auctionName = "Annual Auction 2026", wonItems = DEFAULT_WON_ITEMS, lostItems = [], contributionCents = 500, donorAddress = "San Diego, CA", companyName, paymentMethodDisplay = "Card ending 4242", date = "April 29, 2026", message = exports.FROALA_AUCTION_WINNER_NOTE_BODY, isOfflinePayment = false, isCashPayment = false, offlinePaymentWording, paymentHasFailed = false, } = input;
    const pricedWonItems = wonItems.map((item) => ({
        ...item,
        formattedPrice: formatAmount(item.amountCents),
    }));
    const itemsTotalCents = pricedWonItems.reduce((sum, item) => sum + item.amountCents, 0);
    const isStripePayment = !isOfflinePayment;
    const hasTip = contributionCents > 0 && !paymentHasFailed;
    const paidCents = paymentHasFailed ? itemsTotalCents : itemsTotalCents + contributionCents;
    return {
        labels,
        theme,
        iconZeffyLogo,
        lang,
        isAuction: true,
        subject: "You're a winner!",
        orgName: orgName || "Bright Futures Foundation",
        firstName,
        lastName,
        auctionName,
        address: donorAddress,
        companyName: companyName ?? "",
        date,
        paymentMethodDisplay,
        simplykConnectionLink: MOCK_CONNECTION_LINK,
        message,
        wonItems: pricedWonItems,
        lostItems,
        hasLostItems: lostItems.length > 0,
        tickets: pricedWonItems.map((item) => ({ title: item.name, formattedPrice: item.formattedPrice })),
        hasContribution: hasTip,
        shouldDisplayContributionLine: isStripePayment && !paymentHasFailed,
        contributionAmount: formatAmount(contributionCents),
        shouldDisplayDonorRefundOptionInEmail: hasTip && isStripePayment,
        donorRefundPageLink: MOCK_DONOR_REFUND_LINK,
        paidAmount: formatAmount(paidCents),
        isOfflinePayment,
        isCashPayment,
        offlinePaymentWording: offlinePaymentWording ?? "",
        paymentHasFailed,
    };
};
exports.buildAuctionThankYouWinnerMockData = buildAuctionThankYouWinnerMockData;
const DEFAULT_LOST_ITEMS = [{ name: "Spa getaway for two" }, { name: "Backstage passes to Lakestreet Dive" }];
const buildAuctionThankYouNonWinnerMockData = (input) => {
    const { labels, theme, iconZeffyLogo, lang } = resolveBase(input);
    const { orgName, firstName = "John", lastName = "Smith", auctionName = "Annual Auction 2026", lostItems = DEFAULT_LOST_ITEMS, message = exports.FROALA_AUCTION_NON_WINNER_NOTE_BODY, } = input;
    return {
        labels,
        theme,
        iconZeffyLogo,
        lang,
        subject: "Thank you for your participation!",
        orgName: orgName || "Bright Futures Foundation",
        firstName,
        lastName,
        auctionName,
        message,
        lostItems,
    };
};
exports.buildAuctionThankYouNonWinnerMockData = buildAuctionThankYouNonWinnerMockData;
const buildAuctionOutbidMockData = (input) => {
    const { labels, theme, iconZeffyLogo, lang } = resolveBase(input);
    const { firstName = "John", itemName = "Spa getaway for two", eventClosedDate = "Aug 10, 2026, 8:30 PM EDT", ctaUrl = MOCK_CTA_URL, } = input;
    return {
        labels,
        theme,
        iconZeffyLogo,
        lang,
        subject: "You've been outbid",
        firstName,
        itemName,
        eventClosedDate,
        ctaUrl,
    };
};
exports.buildAuctionOutbidMockData = buildAuctionOutbidMockData;
const buildAuctionNewTopBidderMockData = (input) => {
    const { labels, theme, iconZeffyLogo, lang } = resolveBase(input);
    const { firstName = "John", itemName = "Gift basket", eventClosedDate = "Aug 10, 2026, 8:30 PM EDT", ctaUrl = MOCK_CTA_URL, } = input;
    return {
        labels,
        theme,
        iconZeffyLogo,
        lang,
        subject: "You're now the top bidder",
        firstName,
        itemName,
        eventClosedDate,
        ctaUrl,
    };
};
exports.buildAuctionNewTopBidderMockData = buildAuctionNewTopBidderMockData;
const buildAuctionBidCancelledMockData = (input) => {
    const { labels, theme, iconZeffyLogo, lang } = resolveBase(input);
    const { orgName, firstName = "John", itemName = "Spa getaway for two", bidAmount = "$120", eventClosedDate = "Aug 10, 2026, 8:30 PM EDT", ctaUrl = MOCK_CTA_URL, } = input;
    return {
        labels,
        theme,
        iconZeffyLogo,
        lang,
        subject: "Your bid has been cancelled",
        orgName: orgName || "Bright Futures Foundation",
        firstName,
        itemName,
        bidAmount,
        eventClosedDate,
        ctaUrl,
    };
};
exports.buildAuctionBidCancelledMockData = buildAuctionBidCancelledMockData;
const DEFAULT_BID_ITEMS = [
    { itemPrice: "$180.00", itemName: "Spa Getaway for Two" },
    { itemPrice: "$75.00", itemName: "Backstage Passes to Lakestreet Dive" },
];
const buildAuctionBidPlacedMockData = (input) => {
    const { labels, theme, iconZeffyLogo, lang } = resolveBase(input);
    const { orgName, firstName = "John", auctionName = "Annual Auction 2026", bidItems = DEFAULT_BID_ITEMS, eventClosedDate = "Aug 10, 2026, 8:30 PM EDT", ctaUrl = MOCK_CTA_URL, message, } = input;
    return {
        labels,
        theme,
        iconZeffyLogo,
        lang,
        subject: "Thank you for placing your bid(s)!",
        orgName: orgName || "Bright Futures Foundation",
        firstName,
        auctionName,
        bidItems: bidItems.map((item) => ({
            itemPrice: item.itemPrice,
            itemName: item.itemName,
            bidConnector: item.isAutoBid ? labels.auctionBidConnectorAuto : labels.auctionBidConnectorManual,
            isTaxed: Boolean(item.isTaxed),
        })),
        eventClosedDate,
        ctaUrl,
        message,
    };
};
exports.buildAuctionBidPlacedMockData = buildAuctionBidPlacedMockData;
